module.exports = __webpack_public_path__ + "media/images/wallet_icon_active-a7dcf0b6.svg";